const features = [
  {
    icon: "ri-shield-check-line",
    title: "Military-Grade Security",
    desc: "AES-256 encryption ensures your data is protected at every layer, meeting the highest international security standards.",
  },
  {
    icon: "ri-eye-off-line",
    title: "Zero-Log Privacy",
    desc: "We never store, track, or share your activity. Your digital footprint stays entirely in your hands.",
  },
  {
    icon: "ri-speed-line",
    title: "Optimized Performance",
    desc: "Lightweight architecture keeps your device fast. Our apps run efficiently without draining battery or memory.",
  },
  {
    icon: "ri-smartphone-line",
    title: "iOS Native Design",
    desc: "Built exclusively for iOS, every interaction aligns with Apple's Human Interface Guidelines for a seamless feel.",
  },
  {
    icon: "ri-refresh-line",
    title: "Automatic Updates",
    desc: "Continuous improvements are delivered automatically, keeping your apps secure and up to date at all times.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Local Processing",
    desc: "Sensitive operations are handled on-device — your personal data never leaves your iPhone.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#0a0a0a] py-32 px-6 lg:px-12 relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/c2b01021e45171f1b68c04fd660fecb5.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-0.5 bg-emerald-400" />
            <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase">
              Key Features
            </span>
            <span className="w-8 h-0.5 bg-emerald-400" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Why Choose JEKO?
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
            Every feature is purposefully designed to give iOS users a faster,
            safer, and more private mobile experience.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group rounded-2xl border border-white/5 bg-[#141414] p-8 hover:border-emerald-500/30 hover:bg-[#1a1a1a] transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-400/10 border border-emerald-400/20 mb-6 group-hover:bg-emerald-400/20 transition-colors duration-300">
                <i className={`${feature.icon} text-emerald-400 text-xl`} />
              </div>
              <h3
                className="text-white font-semibold text-lg mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {feature.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom decorative row */}
        <div className="mt-20 grid grid-cols-3 md:grid-cols-6 gap-6">
          {["Security", "Privacy", "Speed", "Reliability", "Simplicity", "iOS-First"].map((tag) => (
            <div
              key={tag}
              className="rounded-full border border-white/5 bg-[#141414] py-2 px-4 text-center text-xs text-gray-500 tracking-widest uppercase"
            >
              {tag}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
